<template>
  <div>
    <div id="builder-import_export"></div>

    <div class="btn-group">
      <button class="btn btn-warning reset" data-target="import_export">Reset</button>
    </div>

    <div class="btn-group">
      <button
        @click="getSQL"
        class="btn btn-primary parse-sql"
        data-target="import_export"
        data-stmt="false"
      >SQL</button>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import "jQuery-QueryBuilder";
export default {
  methods: {
    getSQL() {
      var result = $("#builder-import_export").queryBuilder("getSQL", false);

      if (result.sql.length) {
        alert(result.sql);
      }
    }
  },
  mounted() {
    $("#builder-import_export").queryBuilder({
      plugins: ["not-group"],
      filters: [
        {
          id: "name",
          label: "Name",
          type: "string"
        },
        {
          id: "category",
          label: "Category",
          type: "integer",
          input: "select",
          values: {
            1: "Books",
            2: "Movies",
            3: "Music",
            4: "Tools",
            5: "Goodies",
            6: "Clothes"
          },
          operators: [
            "equal",
            "not_equal",
            "in",
            "not_in",
            "is_null",
            "is_not_null"
          ]
        },
        {
          id: "in_stock",
          label: "In stock",
          type: "integer",
          input: "radio",
          values: {
            1: "Yes",
            0: "No"
          },
          operators: ["equal"]
        },
        {
          id: "price",
          label: "Price",
          type: "double",
          validation: {
            min: 0,
            step: 0.01
          }
        },
        {
          id: "id",
          label: "Identifier",
          type: "string",
          placeholder: "____-____-____",
          operators: ["equal", "not_equal"],
          validation: {
            format: /^.{4}-.{4}-.{4}$/
          }
        }
      ]
    });

    $("#btn-reset").on("click", function() {
      $("#builder-import_export").queryBuilder("reset");
    });

    $("#btn-set-mongo").on("click", function() {
      $("#builder-import_export").queryBuilder(
        "setRulesFromMongo",
        mongo_import_export
      );
    });

    $("#btn-get-sql").on("click", function() {
      var result = $("#builder-import_export").queryBuilder("getSQL", "false");

      if (result.sql.length) {
        alert(result.sql + "\n\n" + JSON.stringify(result.params, null, 2));
      }
    });

    $("#btn-get-mongo").on("click", function() {
      var result = $("#builder-import_export").queryBuilder("getMongo");

      if (!$.isEmptyObject(result)) {
        alert(JSON.stringify(result, null, 2));
      }
    });
  }
};
</script>
<style >
.query-builder .rule-container,
.query-builder .rule-placeholder,
.query-builder .rules-group-container {
  position: relative;
  margin: 4px 0;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #eee;
  background: rgba(255, 255, 255, 0.9);
}
.query-builder .drag-handle,
.query-builder .error-container,
.query-builder .rule-container .rule-filter-container,
.query-builder .rule-container .rule-operator-container,
.query-builder .rule-container .rule-value-container {
  display: inline-block;
  margin: 0 5px 0 0;
  vertical-align: middle;
}
@media (min-width: 768px) .form-inline .form-control {
  display: inline-block;
  width: auto;
  vertical-align: middle;
}
.query-builder .rules-group-container {
  padding: 10px;
  padding-bottom: 6px;
  border: 1px solid #dcc896;
  background: rgba(250, 240, 210, 0.5);
}
.query-builder,
.query-builder * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.query-builder {
  font-family: sans-serif;
}

.query-builder .hide {
  display: none;
}

.query-builder .pull-right {
  float: right !important;
}

.query-builder .btn {
  text-transform: none;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.query-builder .btn.focus,
.query-builder .btn:focus,
.query-builder .btn:hover {
  color: #333;
  text-decoration: none;
}

.query-builder .btn.active,
.query-builder .btn:active {
  background-image: none;
  outline: 0px none;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.125) inset;
}

.query-builder .btn-success {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
}

.query-builder .btn-primary {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}

.query-builder .btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}

.query-builder .btn-success.active,
.query-builder .btn-success.focus,
.query-builder .btn-success:active,
.query-builder .btn-success:focus,
.query-builder .btn-success:hover {
  color: #fff;
  background-color: #449d44;
  border-color: #398439;
}

.query-builder .btn-primary.active,
.query-builder .btn-primary.focus,
.query-builder .btn-primary:active,
.query-builder .btn-primary:focus,
.query-builder .btn-primary:hover {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}

.query-builder .btn-danger.active,
.query-builder .btn-danger.focus,
.query-builder .btn-danger:active,
.query-builder .btn-danger:focus,
.query-builder .btn-danger:hover {
  color: #fff;
  background-color: #c9302c;
  border-color: #ac2925;
}

.query-builder .btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.query-builder .btn-group > .btn {
  position: relative;
  float: left;
}

.query-builder .btn-group > .btn:first-child {
  margin-left: 0px;
}

.query-builder .btn-group > .btn:first-child:not(:last-child) {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.query-builder .btn-group > .btn:last-child:not(:first-child) {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.query-builder .btn-group .btn + .btn,
.query-builder .btn-group .btn + .btn-group,
.query-builder .btn-group .btn-group + .btn,
.query-builder .btn-group .btn-group + .btn-group {
  margin-left: -1px;
}

.query-builder .btn-xs,
.query-builder .btn-group-xs > .btn {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/Test.vue